export class ConfirmData {
  title: string;
  description: string;
}
